import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { deleteIssueFile, uploadFile } from '../../../../packages/common/api';
import DeleteFileIcon from '../../../../packages/common/shared-ui/src/icons/DeleteFileIcon';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';

// Original class: hoveredIcon
const StyledHoveredIcon = styled(IconButton)(theme => ({
  '& .MuiSvgIcon-root': {
    '& path': {
      transition: '.2s ease',
    },
  },

  '&:hover': {
    '& .MuiSvgIcon-root': {
      '& path': {
        fill: '#7174AC',
      },
    },
  },
}));

const IssueFileUpload = ({ handleUpload, data }) => {
  const getLocalString = useTranslation();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data && data.valueName && data.valueId) {
      const id = data.valueId.split('/')[3];
      setFile({ fileName: data.valueName, fileId: id });
    }
  }, [data]);

  const handleFileUpload = useCallback(
    async event => {
      setLoading(true);
      const { data: fileData } = await uploadFile(
        event.target.files[0],
        event.target.files[0].name,
      );
      if (fileData.upload.token) {
        const data = {
          token: fileData.upload.token,
          fileName: event.target.files[0].name,
          contentType: event.target.files[0].type,
        };
        setFile(data);
        handleUpload(data);
        setLoading(false);
      }
    },
    [handleUpload],
  );

  const handleDeleteIssueFile = useCallback(() => {
    setFile(null);
    handleUpload(null);
  }, [handleUpload]);

  return (
    <>
      {file ? (
        <Grid
          container
          sx={{
            alignItems: 'center',
            height: '36px',
          }}
        >
          <Grid>
            <Typography
              variant='h4'
              sx={{
                color: '#7174AC',
              }}
            >
              {file.fileName}
            </Typography>
          </Grid>
          <Grid sx={{ display: 'flex', marginLeft: '13px' }}>
            <StyledHoveredIcon
              sx={{ padding: '0', marginLeft: '4px' }}
              onClick={() => handleDeleteIssueFile()}
            >
              <DeleteFileIcon />
            </StyledHoveredIcon>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          sx={{
            alignItems: 'center',
          }}
        >
          <Button
            variant='defaultGreyPrimary'
            component='label'
            sx={{ minWidth: '115px', padding: '6px 16px' }}
          >
            <Typography variant='h5'>
              {getLocalString('labels', 'selectFile')}
            </Typography>
            <input
              hidden
              multiple
              type='file'
              onChange={event => handleFileUpload(event)}
            />
          </Button>
          {loading && (
            <Grid
              container
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                width: '30px',
                height: '30px',
                marginLeft: '10px',
              }}
            >
              <CircularProgress size={20} color='secondary' />
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
};

export default IssueFileUpload;
